import React from 'react';
import Popover from '../../../../../../components/Popover';
import {
  useActionsVisibilityContext,
  withActionsVisibilityContext,
} from '../../../../../../components/ActionsVisibilityContext';
import { NamedFilterLabel } from '../../../../../../components/EntityLabels';
import FilterWidget from '../../../../../../components/FilterWidget';
import { IPredicateContext } from '../../../../../../components/FilterWidget/types';
import { SvgIcon } from '../../../../../../components/Icon';
import { useAppDispatch } from '../../../../../../redux/hooks';
import {
  dashboardCustomizationExpandNamedFilter,
  dashboardCustomizationSetFilter,
} from '../../../../../../redux/slices/dashboards/dashboardInstance';
import { defaultEventInput } from '../../../../../../utils/builder';
import {
  FieldContext,
  IFilterFieldsFragment,
  INamedFilterFieldsFragment,
} from '../../../../../../utils/apollo/graphqlSchema';
import useDashboardSchemaId from '../../../../utils/useDashboardSchemaId';
import * as DashboardFilterViewUI from './DashboardFilterViewUI';
import usePopoverController from '../../../../../../components/Popover/usePopoverController';
import { assertNotNil } from '../../../../../../utils/types';

interface IProps {
  filter: INamedFilterFieldsFragment;
}

const predicateContext: IPredicateContext = {
  fieldContext: FieldContext.Filter,
  events: [defaultEventInput],
  func: null,
};

const DashboardFilterNamedFilter = ({ filter }: IProps) => {
  const { closePopover, isPopoverOpen, openPopover, popoverAnchor } =
    usePopoverController<HTMLDivElement>();
  const schemaId = useDashboardSchemaId();
  assertNotNil(schemaId);

  const dispatch = useAppDispatch();
  const { showActions, hideActions, actionsVisible } =
    useActionsVisibilityContext();

  const expandNamedFilter = () => {
    dispatch(dashboardCustomizationExpandNamedFilter());

    hideActions();
  };

  const handleRemoveNamedFilter = () => {
    dispatch(
      dashboardCustomizationSetFilter({
        newFilter: null,
      }),
    );
  };

  const handleSubmitNewFilter = (newFilter: IFilterFieldsFragment) => {
    dispatch(
      dashboardCustomizationSetFilter({
        newFilter,
      }),
    );

    closePopover();
  };

  return (
    <>
      <DashboardFilterViewUI.EditableLabel
        ref={popoverAnchor}
        onMouseEnter={showActions}
        onMouseLeave={hideActions}
        $isActionsVisible={actionsVisible}
      >
        <NamedFilterLabel
          namedFilter={filter}
          onExpandNamedFilter={expandNamedFilter}
          backgroundColor="transparent"
          onClick={openPopover}
        />
        {actionsVisible && (
          <DashboardFilterViewUI.ActionContainer
            onClick={handleRemoveNamedFilter}
          >
            <SvgIcon name="icon-x" width={8} height={8} />
          </DashboardFilterViewUI.ActionContainer>
        )}
      </DashboardFilterViewUI.EditableLabel>
      <Popover
        anchor={popoverAnchor.current}
        isOpen={isPopoverOpen}
        close={closePopover}
      >
        <FilterWidget
          onSubmit={handleSubmitNewFilter}
          schemaId={schemaId}
          context={predicateContext}
          defaultFilter={filter}
          defaultLogOps={[]}
          maxConditions={1}
          maxPredicates={1}
          includeAnyValue={true}
        />
      </Popover>
    </>
  );
};

export default withActionsVisibilityContext(DashboardFilterNamedFilter);
